import { Skeleton, Stack } from 'design-library';

export default function LoadingState() {
  return (
    <Stack paddingX={4} paddingY={4} width={1}>
      <Skeleton variant="rounded" sx={{ height: '400px' }} />
      <Skeleton variant="text" sx={{ fontSize: '3rem' }} width={'70%'} />
      <Skeleton variant="text" sx={{ fontSize: '2rem' }} width={'40%'} />
      <Skeleton variant="text" sx={{ fontSize: '2rem' }} width={'60%'} />
      <Skeleton height={'400px'} width={'75%'} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={'60%'} />
    </Stack>
  );
}
